import { IComponentCO2UpdateSchema } from '@acies/schema';

/** The EditComponentCO2Model is responsible for all the edit view binding properties and returning a correctly shaped edit ComponentCO2 body Object. */
export default class EditComponentCO2Model {
	public epd: string;
	public name: string;
	public description: string;
	public a1: string;
	public a2: string;
	public a3: string;
	public a4: string;
	public a5: string;
	public c1: string;
	public c2: string;
	public c3: string;
	public c4: string;
	public d: string;
	public updateButtonEnabled: boolean;
	public editButtonEnabled: boolean;
	public editSpinnerVisible: boolean;
	public networkErrorLabelVisible: boolean;
	public unknownErrorLabelVisible: boolean;
	public constructor() {
		this.updateButtonEnabled = true;
		this.editButtonEnabled = false;
		this.editSpinnerVisible = false;
		this.networkErrorLabelVisible = false;
		this.unknownErrorLabelVisible = false;
		this.resetUIBindings();
	}

	public resetUIBindings(): void {
		this.epd = '';
		this.name = '';
		this.description = '';
		this.a1 = '';
		this.a2 = '';
		this.a3 = '';
		this.a4 = '';
		this.a5 = '';
		this.c1 = '';
		this.c2 = '';
		this.c3 = '';
		this.c4 = '';
		this.d = '';
	}

	/**
	 * Returns a correctly shaped Object that we use in the CO2Service.
	 *
	 * Notice that we can convert from a correctly formatted scientific string, directly to the number representation with the NumberConstructor() function.
	 *
	 * The replace(',', '.') has to be run before updating, since the input could be in danish scientific notation or international which uses dot instead of comma.
	 */
	public get updateComponentCO2Body(): IComponentCO2UpdateSchema {
		return {
			description: this.description,
			epd: this.epd,
			name: this.name,
			phases: {
				a1: Number(this.a1.replace(',', '.')),
				a2: Number(this.a2.replace(',', '.')),
				a3: Number(this.a3.replace(',', '.')),
				a4: Number(this.a4.replace(',', '.')),
				a5: Number(this.a5.replace(',', '.')),
				c1: Number(this.c1.replace(',', '.')),
				c2: Number(this.c2.replace(',', '.')),
				c3: Number(this.c3.replace(',', '.')),
				c4: Number(this.c4.replace(',', '.')),
				d: Number(this.d.replace(',', '.')),
			},
		};
	}
}
